// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c006b0f","239":"d99803fe","732":"019c2363"}[chunkId] + ".chunk.js";
};